import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Ticket, HelpCircle, Grid3x3, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Games() {
  const games = [
    {
      title: "Digital Raffle",
      description: "Create raffles with automated draws, animated results, and email notifications to winners.",
      icon: Ticket,
      features: ["License confirmation", "Online ticket sales", "Email results", "Fundraising page display"],
      path: "/games/raffle"
    },
    {
      title: "Guessing Game",
      description: "Weight, name, or number guessing games with image upload and automatic or manual winner selection.",
      icon: HelpCircle,
      features: ["Image upload", "No duplicate guesses", "Auto/manual winner", "Email results"],
      path: "/games/guessing"
    },
    {
      title: "Bingo Caller",
      description: "Interactive bingo with audio calls, animations, QR code for players, and speed control.",
      icon: Grid3x3,
      features: ["Audio phrases", "QR code for players", "Speed control", "Auto/manual play"],
      path: "/games/bingo"
    },
  ];

  return (
    <div className="container py-6">
      <div className="max-w-4xl space-y-8 animate-fade-in">
      <div>
        <h1 className="text-3xl font-semibold text-foreground">Games</h1>
        <p className="text-muted-foreground mt-1">
          Interactive games to engage your community and raise funds
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-5">
        {games.map((game) => {
          const Icon = game.icon;
          return (
            <Link key={game.title} to={game.path} className="group">
              <Card className="h-full shadow-card hover:shadow-elevated transition-all group-hover:border-primary/30">
                <CardHeader className="pb-3">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <CardTitle className="text-base">{game.title}</CardTitle>
                  <CardDescription className="text-xs leading-relaxed">{game.description}</CardDescription>
                </CardHeader>
                <CardContent className="pt-0">
                  <ul className="space-y-1 mb-4">
                    {game.features.map((feature, i) => (
                      <li key={i} className="text-xs text-muted-foreground flex items-center gap-1.5">
                        <span className="w-1 h-1 rounded-full bg-primary shrink-0" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <div className="flex items-center text-sm font-medium text-primary group-hover:gap-2 transition-all gap-1">
                    Open <ArrowRight className="h-3.5 w-3.5" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
      </div>
    </div>
  );
}
